/**
 * TaskTimeLogService
 * Service for TaskTimeLog entity operations
 * Route: api/task-time-logs
 * Controller: TaskTimeLogController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * TaskTimeLogService
 * Handles task time log CRUD operations
 * Maps to /api/task-time-logs endpoint
 */
export class TaskTimeLogService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskTimeLogService.DEFAULT_SERVICE_PATH,
            basePath: TaskTimeLogService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
TaskTimeLogService.DEFAULT_SERVICE_PATH = 'projects';
TaskTimeLogService.BASE_PATH = 'api/task-time-logs';
//# sourceMappingURL=TaskTimeLogService.js.map